module.exports = __webpack_public_path__ + "static/framtidsmedia-partner-c0b42f9e3bacdf41ea4c6cb38f4ca6c0.png";